import { Tag } from "antd";

import styles from "./ValidationTag.module.css";
import { VALIDATION_OPTIONS } from "../../utils/constants";

const validationColors: { [key: string]: string } = {
  REVISION: "#FFF0B3",
  VALIDATED: "#D9F2EF",
  DEFAULT: "#F0F0F0",
};

const ValidationTag = ({
  validated_at,
}: {
  validated_at?: string;
}) => {

  const validationStatus = validated_at ? "VALIDATED" : "REVISION";
  const validationOption = VALIDATION_OPTIONS.find(option => option.value === validationStatus);
  const tagText = validationOption?.label || "-";
  const tagColor = validationColors[validationStatus] || validationColors.DEFAULT;

  return (
    <Tag className={styles.tag} style={{ backgroundColor: tagColor }}>
      {tagText}
    </Tag>
  );
};

export default ValidationTag;
